import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance90 = () => {
  let winners = ["276", "524", "158", "415", "48", "301", "523", "219"];
  return <IndividualTable matchType={"16"} gender="F" event="90" subTitle="TarscaShild" data={sampleData2} topRankCount="8" winners={winners} />;
};
export default Distance90;
